import "@/App.css";
import "@/theme-fresh.css";
import "@/leaf.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Sanctuary from "@/pages/Sanctuary";
import Grove from "@/pages/Grove";
import Canopy from "@/pages/Canopy";
import Team from "@/pages/Team";
import Services from "@/pages/Services";
import Funding from "@/pages/Funding";
import Parenting from "@/pages/Parenting";
import Professionals from "@/pages/Professionals";
import Refer from "@/pages/Refer";
import Contact from "@/pages/Contact";
import Book from "@/pages/Book";
import Affiliates from "@/pages/Affiliates";
import Practice from "@/pages/Practice";
import Eap from "@/pages/Eap";
import Newsletter from "@/pages/Newsletter";
import FamilyReports from "@/pages/FamilyReports";
import Enquire from "@/pages/Enquire";
import { ScrollToTop, useLenis } from "@/components/shared";

function App() {
  useLenis();
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Sanctuary />} />
          <Route path="/grove" element={<Grove />} />
          <Route path="/canopy" element={<Canopy />} />
          <Route path="/team" element={<Team />} />
          <Route path="/services" element={<Services />} />
          <Route path="/funding" element={<Funding />} />
          <Route path="/parenting" element={<Parenting />} />
          <Route path="/professionals" element={<Professionals />} />
          <Route path="/refer" element={<Refer />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/book" element={<Book />} />
          <Route path="/affiliates" element={<Affiliates />} />
          <Route path="/practice" element={<Practice />} />
          <Route path="/eap" element={<Eap />} />
          <Route path="/newsletter" element={<Newsletter />} />
          <Route path="/pathways" element={<Navigate to="/refer#pathways" replace />} />
          <Route path="/resources" element={<Navigate to="/" replace />} />
          <Route path="/family-reports" element={<FamilyReports />} />
          <Route path="/fees" element={<Navigate to="/funding#fees" replace />} />
          <Route path="/enquire" element={<Enquire />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
